<div class="container">
  <ul class="progressbar">
    <li [ngClass]="{ active: step === 1 }">Select Doctor</li>
    <li [ngClass]="{ active: step === 2 }">Register</li>
    <li [ngClass]="{ active: step === 3 }">Consult Information</li>
    <li [ngClass]="{ active: step === 4 }">Video Call</li>
  </ul>
</div>
